export const DELIVERY_FORM_FIELDS = {
  ADDRESS: 'address',
  DATE_SLOT: 'dateSlot',
  TIME_SLOT: 'timeSlot',
} as const;

export const DELIVERY_FORM_FIELDS_LABELS_CONFIG = {
  [DELIVERY_FORM_FIELDS.ADDRESS]: 'Адрес',
  [DELIVERY_FORM_FIELDS.DATE_SLOT]: 'Дата',
  [DELIVERY_FORM_FIELDS.TIME_SLOT]: 'Время',
} as const;

export const DELIVERY_TEXTS = {
  button: 'Подтвердить',
  addressError: 'Не удалось распознать адрес, введите его заново',
  slotsError: 'Попробуйте другой адрес',
};
